export const relationship = [
  { label: '法定繼承人', value: '10' },
  { label: '配偶', value: '02' },
  { label: '子女', value: '03' },
  { label: '父母', value: '04' },
  { label: '(外)祖父母', value: '07' },
  { label: '(外)孫子女', value: '08' },
];

export const famiyYearIncome = [
  { label: '50萬以下', value: '500000' },
  { label: '51-100萬', value: '1000000' },
  { label: '100-150萬', value: '1500000' },
  { label: '150-200萬', value: '2000000' },
  { label: '200萬以上', value: '2010000' }
];

export const economicSources = [
  { label: '本人', value: '1' },
  { label: '配偶', value: '2' },
  { label: '父母', value: '3' },
  { label: '子女', value: '4' }//,  //20210530Wen Modify
 // { label: '其他', value: '5' }
];

export const job = [
  { label: '一般職業/行業', value: 'A' },
  { label: '律師、會計師、公證人、或是其合夥人或受僱人', value: 'B1' },
  { label: '軍火商、不動產經紀人', value: 'B2' },
  { label: '當鋪業、融資從業人員', value: 'B3' },
  { label: '寶石及貴金屬交易商', value: 'B4' },
  { label: '藝術品/骨董交易商、拍賣公司', value: 'B5' },
  { label: '基金會、協會/寺廟、教會從業人員', value: 'B6' },
  { label: '博弈產業/公司', value: 'B7' },
  { label: '匯款公司、外幣兌換所', value: 'B8' },
  { label: '外交人員、大使館、辦事處', value: 'B9' },
  { label: '虛擬貨幣的發行者或交易商', value: 'B10' }
];

export const type = [
  { label: '國內自然人', value: '1' },
  { label: '國內法人', value: '2' },
  { label: '國外自然人', value: '3' }  
];

export const autojob = [
  { label: '一般職業/行業', value: 'N' },
  { label: '律師(或其合夥人/受僱人)', value: '001' },
  { label: '會計師(或其合夥人/受僱人)', value: '002' },  
  { label: '公證人(或其合夥人/受僱人)', value: '003' },
  { label: '軍火商、不動產經紀人', value: '004' },
  { label: '融資從業人員', value: '005' },  
  { label: '寺廟、教會從業人員', value: '006' },  
  { label: '外交人員、大使館、辦事處', value: '007' },
  { label: '虛擬貨幣的發行者或交易商', value: '008' },
  { label: '當鋪業', value: '009' },
  { label: '寶石及貴金屬交易商', value: '010' },
  { label: '藝術品/骨董交易商', value: '011' },
  { label: '拍賣公司', value: '012' },
  { label: '基金會', value: '013' },
  { label: '協會', value: '014' },
  { label: '博弈產業/公司', value: '015' },
  { label: '匯款公司', value: '016' },
  { label: '外幣兌換所', value: '017' }
];

export const pro = [
  { label: '非專業客戶', value: 'A' },
  { label: '專業客戶', value: 'B' }  
];

export const accidentrelationship = [
  { label: '本人', value: '01' }  
];

export const insurRelationship = [ 
  { label: '本人', value: '01' },
  { label: '父母', value: '04' }  
];